import ExhibitorEditText from './ExhibitorEditText';

const ExhibitorEditDescr = () => {
    return (
        <ExhibitorEditText fname='descr' subtitle='exhibitoredit.descr_hint' limit={600} />
	);
};

export default ExhibitorEditDescr;
